// client/src/routes/app/settings/notification-rules.tsx — SCR-SET-005 · ALR-004 (04 §8.18).
//
// The route is new: UI-003 held `/app/settings` and AUTH-004 turned it into the §8.18 layout
// with two tabs. This is the third, and it adds one `<Link>` to `settings/route.tsx`.
//
// No `RequirePermission` wrapper. §8.18 describes this child as a „per-user prefs + org rules
// split", and the per-user half is every member's — `Notifications.Read`, held by every seeded
// role in this shell. The org half is behind `Notifications.ManageRules` and gates ITSELF
// inside the screen, which is why the guard cannot sit here: a wrapper would hide the half
// that belongs to everyone in order to protect the half that does not.

import { createFileRoute } from '@tanstack/react-router';

import { NotificationRulesScreen } from '@/features/notifications/NotificationRulesScreen';

export const Route = createFileRoute('/app/settings/notification-rules')({
  component: NotificationRulesScreen,
});
